import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import i18n from "../../i18n";
const createAxiosInstance = () => {
  const token = sessionStorage.getItem("usr_1a2b3c");
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// Async thunk to fetch doctor dashboard metrics
export const fetchDoctorDashboardMetrics = createAsyncThunk(
  "doctorDashboardMetrics/fetch",
  async (arg, { rejectWithValue }) => {
    try {
      const orderType = arg?.order_type === "insured" ? "insured" : "normal";
      const axiosInstance = createAxiosInstance();
      const params = new URLSearchParams({ order_type: orderType });
      if (arg?.date_from) params.append("date_from", arg.date_from);
      if (arg?.date_to) params.append("date_to", arg.date_to);
      const response = await axiosInstance.get(
        `/api/v1/consultation/doctor/wallet/dashboard-metrics?${params.toString()}`,
      );

      return response.data.data;
    } catch (error) {
      console.error("Error fetching doctor dashboard metrics:", error);
      return rejectWithValue(
        error.response?.data?.message || i18n.t("toast.failedToFetchDashboardMetrics"),
      );
    }
  },
);

const doctorDashboardMetricsSlice = createSlice({
  name: "doctorDashboardMetrics",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearDashboardMetrics: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctorDashboardMetrics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDoctorDashboardMetrics.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchDoctorDashboardMetrics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDashboardMetrics } = doctorDashboardMetricsSlice.actions;
export default doctorDashboardMetricsSlice.reducer;
